import { faLeaf, faHandshake, faSitemap, faMapMarkerAlt, faUsers, } from '@fortawesome/free-solid-svg-icons';
export const CATEGORY_CONFIG = {
    EMPLOYMENT: {
        color: 'var(--main-green-5)',
        label: 'Emploi',
        icon: faUsers,
    },
    ENVIRONMENT: {
        color: 'var(--main-orange)',
        label: 'Environnement',
        icon: faLeaf,
    },
    GOVERNANCE: {
        color: 'var(--main-blue-5)',
        label: 'Gouvernance',
        icon: faSitemap,
    },
    SOCIAL: {
        color: 'var(--main-red-1)',
        label: 'Social',
        icon: faHandshake,
    },
    TERRITORY: {
        color: 'var(--main-blue-6)',
        label: 'Territoire',
        icon: faMapMarkerAlt,
    },
    OTHER: {
        color: '',
        label: '',
        icon: faMapMarkerAlt,
    },
};
//# sourceMappingURL=Config.js.map